import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/animation-polish.css";
import App from "@/App";

// Register service worker for PWA with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    console.log('🐾 App: Window loaded, registering service worker...');
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('🐾 Service Worker registered successfully!');
        console.log('🐾 Service Worker scope:', registration.scope);
        console.log('🐾 Service Worker state:', registration.active?.state || 'installing');
        
        // Check for updates every 5 minutes (reduced from 60s to prevent loops)
        setInterval(() => {
          registration.update();
        }, 300000); // 5 minutes
        
        // Check for updates when user returns to tab
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) {
            registration.update();
          }
        });
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          console.log('🐾 Service Worker: Update found!');
          const newWorker = registration.installing;
          
          newWorker.addEventListener('statechange', () => {
            console.log('🐾 Service Worker state changed to:', newWorker.state);
            
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker installed, reload to activate
              console.log('🐾 New version available! Reloading...');
              window.location.reload();
            }
          });
        });
      })
      .catch((error) => {
        console.error('🐾 Service Worker registration failed:', error);
      });
  });
  
  // Listen for cache update messages (no auto-reload to prevent loops)
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      console.log('🐾 Cache updated notification received (no reload needed - already handled)');
      // Note: We already reload on line 40 when update is detected
      // Reloading here causes infinite loops!
    }
  });
  
  // Log when service worker becomes active
  navigator.serviceWorker.ready.then((registration) => {
    console.log('🐾 Service Worker is ready and active!');
  });
} else {
  console.warn('🐾 Service Workers are not supported in this browser');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

